import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { FormTextField } from "../../common/form-fields-wrappers"
import { RecoveryCompany, IExpiredThresholdForm } from "../../models/models"
import { useTranslation } from "react-i18next"
import Box from "@mui/material/Box"
import { useFieldArray } from "react-hook-form"
import { Grid, useTheme } from "@mui/material/index"

const RecoveryCompanies = () => {

    const {t} = useTranslation(['expiredManagement']);
    const theme = useTheme();
    
    const { fields } = useFieldArray<IExpiredThresholdForm>({name: 'recoveryCompanies'});
    
    return (
        <Box pt={1} pb={1}>
            <Stack direction={"column"} gap={2}>
                    <Typography variant={'h5'} fontWeight={"bold"} color={"primary"}>{t('expiredConfiguration.form.competence')}</Typography>
                    <Grid container spacing={theme.spacing(2)} > 
                        {
                            fields.map((rc: RecoveryCompany, index: number) =>
                                <Grid item xs={12} sm={3} key={`grid-${rc.name}`}>
                                    <FormTextField<IExpiredThresholdForm>
                                        key={`${rc.name}`}
                                        name={`recoveryCompanies.${index}.amount`}
                                        label={t(`${rc.name}`)}
                                        type="number"
                                        /*InputProps={{
                                            endAdornment: <Euro style={{ fontSize: '15px' }} />
                                        }}*/
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
            </Stack>
        </Box>
    )
}

export default RecoveryCompanies;